import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { BillingPayRates } from 'src/app/perdiem/components/pay-rate/models/pay-rates.model';
import { BillingPayRate } from 'src/app/perdiem/components/pay-rate/models/pay-rate.model';
import dayjs from 'dayjs';
import { LocalDateTimeFormat } from 'src/app/shared/helpers/noda-time-format';
import { FetchArgs } from 'src/app/shared/models/core';
import { buildHttpParams } from 'src/app/shared/utilities/interpolate-params';

@Injectable({
    providedIn: 'root'
})
export class PayRateService {
    constructor(private readonly _httpClient: HttpClient, @Inject(APP_CONFIG) private readonly _settings: Settings) {}

    getPayRates(facilityId: number): Observable<BillingPayRates> {
        return this._httpClient.get<BillingPayRates>(
            `${this._settings.coreAPIUrl}AyaNova/PerDiemPayRates/facility/${facilityId}`
        );
    }

    getIncentivePayRates(facilityId: number, args: FetchArgs): Observable<BillingPayRates> {
        const params = {};
        buildHttpParams(params, args, '');
        return this._httpClient.get<BillingPayRates>(
            `${this._settings.coreAPIUrl}AyaNova/PerDiemPayRates/incentive/facility/${facilityId}`,
            { params }
        );
    }

    updatePayRates(facilityId: number, request: BillingPayRates): Observable<unknown> {
        return this._httpClient.put(
            `${this._settings.coreAPIUrl}AyaNova/PerDiemPayRates/facility/${facilityId}`,
            request
        );
    }

    updateIncentivePayRates(facilityId: number, request: BillingPayRates): Observable<unknown> {
        const transformedRequest = {
            perDiemPayRates: (request.perDiemPayRates as BillingPayRate[]).map((rate) => {
                const transformedRate = {};
                const rateKeys = Object.keys(rate);
                rateKeys.forEach((key) => {
                    if ((key === 'startDate' || key === 'endDate') && rate[key]) {
                        transformedRate[key] = dayjs(rate[key]).format(LocalDateTimeFormat);
                    } else {
                        transformedRate[key] = rate[key];
                    }
                });

                return transformedRate;
            })
        };
        return this._httpClient.patch(
            `${this._settings.coreAPIUrl}AyaNova/PerDiemPayRates/incentive/facility/${facilityId}`,
            transformedRequest
        );
    }

    getPerDiemShiftDifferentialType(): Observable<Lookup[]> {
        const url = `${this._settings.coreAPIUrl}AyaNova/PerDiemPayRates/shift-differential-types`;
        return this._httpClient.get<Lookup[]>(url);
    }
}
